/*@flow*/
import type { GoogleButton } from '../types';
import { camelize } from 'humps';

// USAGE:
//
//  var url = '...entry.1319750738=name'
//  getFilledUrl({fields: ['name'], url }, { name: 'MY BIZ' })
//  =>  "...entry.1319750738=MY%20BIZ"
//
export default (config: GoogleButton, valueMap: { [key: string]: any }): void | string => {
  if (!valueMap) return;
  const { fields, urlTemplate } = config;
  if (!urlTemplate) return;
  let s = urlTemplate;
  fields.forEach(k => {
    s = s.replace(`__${k}__`, valueMap[camelize(k)]);
  });
  return s;
};
